import { Outlet } from 'react-router-dom';

// Layout route element for routes that should NOT render the v3 GNB
// (login, signup, reset-password). Mirrors the prototype's
// `body[data-page="login"]` toggle by simply omitting the shell.
export function StandaloneLayout() {
  return <Outlet />;
}
